import React from 'react';
import useAxios from 'axios-hooks';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { IStaticInfos } from '../types/strapi';

import groceries from '../assets/images/groceries.png';
import organics from '../assets/images/organics.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  loadingBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
  },
  topImage: {
    maxWidth: '100%',
  },
  info: {
    backgroundColor: theme.palette.secondary.main,
    display: 'grid',
    gridTemplateColumns: '25% 75%',
    alignItems: 'center',
    justifyItems: 'center',
    color: '#fff',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '100%',
    },

    '& > *': {
      margin: theme.spacing(2),
    },
    '& div': {
      fontWeight: 600,
      textAlign: 'justify',
      justifySelf: 'flex-start',
      padding: theme.spacing(2),
      lineHeight: 1.83,
    },
  },
  descriptionBox: {
    display: 'flex',
    alignItems: 'stretch',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
    '& > *': {
      [theme.breakpoints.down('xs')]: {
        maxWidth: '100%',
      },
    },

    '& .description': {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: 2.33,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: '33.3%',
        left: '50%',
        marginLeft: '-16.6%',
      },
      [theme.breakpoints.down('xs')]: {
        left: 0,
        right: 0,
        bottom: 'unset',
        width: '100%',
        margin: 0,
        top: '40%',
      },

      '& span': {
        textAlign: 'justify',
      },
    },
  },
  bottomImage: {
    position: 'relative',
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
    '& .image': { width: '100%' },
    '& .text': {
      top: '0',
      left: '0',
      color: '#fff',
      position: 'absolute',
      fontSize: '25px',
      fontWeight: '600',
      letterSpacing: '0.5px',
      backgroundColor: '#263f427b',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '5% 10%',
      lineHeight: 2.5,
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        position: 'relative',
        backgroundColor: '#fff',
        color: theme.palette.primary.main,
      },
    },
  },
}));

const Azienda: React.FC = () => {
  const classes = useStyles();

  const [{ data: staticInfos, loading }] = useAxios<IStaticInfos>('static-info');

  return (
    <Container disableGutters className={classes.root}>
      {loading && (
        <Box className={classes.loadingBox}>
          <CircularProgress color="inherit" />
        </Box>
      )}
      {staticInfos && (
        <>
          <img className={classes.topImage} src={staticInfos.aziendaTopImage.url} alt="" />
          <Box className={classes.info} style={{ borderBottom: 'solid 1px #263f4242' }}>
            <img src={organics} alt="" />
            <div>
              Dall’amore per la nostra terra e dalla capacità di coltivare prodotti genuini a chilometro zero, nasce
              L’ORTO.
            </div>
          </Box>
          <Box className={classes.info}>
            <img src={groceries} alt="" />
            <div>
              L’Azienda Agricola F.lli Compagnoni si sviluppa su una superficie di circa 10 ettari nella campagna
              Mirandolese nelle frazioni di Quarantoli e di Tramuschio dove è situato il negozio al dettaglio.
            </div>
          </Box>
          <Box className={classes.descriptionBox}>
            <img src={staticInfos.aziendaAlessandro.url} alt="" />
            <Typography className="description">
              <span>
                Siamo Alessia e Alessandro Compagnoni, produciamo e commercializziamo ortaggi e frutta nel rispetto
                delle norme sull’utilizzo di concimi e fertilizzanti per coltivare prodotti di qualità nel
                <b> rispetto dell’ambiente</b> e della salubrità delle persone.
              </span>
            </Typography>
            <img src={staticInfos.aziendaAlessia.url} alt="" />
          </Box>
          <Box className={classes.info}>
            <div></div>
            <div>
              <div>Contributi ricevuti per acquisto e realizzazione</div>
              <div>
                <p>GRUPPO DISERBO CON BARRA IDRAULICA DA 15 MT OSELLA</p>
                <p>OPERE DI FINITURA NEGOZIO, LABORATORIO PREPARAZIONE ORTAGGI E ARREDI.</p>
                <p>Con contributi in conto capitale ai sensi del:</p>
                <p>
                  REG. (UE) N. 1305/2013 - PSR 2014/2020 - MISURA 4 - TIPO OPERAZIONE 4.1.01 "INVESTIMENTI IN AZIENDE
                  AGRICOLE IN APPROCCIO INDIVIDUALE E DI SISTEMA" - APPROCCIO INDIVIDUALE. FOCUS AREA 2A
                </p>
                <p>DOMANDA DI SOSTEGNO AGREA N. 5511653</p>
                <p>DOMANDA DI PAGAMENTO – SALDO N. 5863320</p>
              </div>
            </div>
          </Box>
          <Box className={classes.bottomImage}>
            <div className="text">
              Il raccolto giornaliero, eseguito a mano, viene pulito con cura per consegnare ai nostri clienti prodotti
              sempre al top! Dalla campagna direttamente al negozio e anche fino a casa tua!
            </div>
            <img className="image" src={staticInfos.aziendaBottomImage.url} alt="" />
          </Box>
        </>
      )}
    </Container>
  );
};

export default Azienda;
